/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unused-state */
import React, { Component, Suspense } from "react";
import ErrorIcon from '@mui/icons-material/Error';
// import * as Sentry from '@sentry/browser'
import { CircularProgress } from '@mui/material';

class ErrorBoundaryWithSuspense extends Component<unknown, { 
	hasError: boolean,
	// errorPassed: {},
	// infoPassed: {},
	error: string, // (added for Sentry)
	eventId: string, // add this to state (added for Sentry)
	errorInfo: React.ErrorInfo, // (added for Sentry)
	description?: string;
	children?: React.ReactNode;
	key?: string;
}>  {
	constructor(props: unknown) {
		super(props);

		this.state = {
			// errorPassed: {},
			// infoPassed: {},
			error: '', // (added for Sentry)
			eventId: '', // add this to state (added for Sentry)
			errorInfo: {componentStack: ""}, // (added for Sentry)
			hasError: false,
		};
	}

	static getDerivedStateFromError(error: unknown) {
		return {
			hasError: true,
			error
		};
	}

	// componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
		// Sentry.withScope((scope: { setExtras: (arg0: any) => void; }) => {
		// 	scope.setExtras(errorInfo);
		// 	const eventId = Sentry.captureException(error);
		// 	this.setState({ eventId, errorInfo });
		// });
	// }

	render() {
		if (this.state.hasError) {
			return (
			
				<div className="card my-5"
					style={{
						height: "100%",
						overflow: "auto",
						color: "darkred",
					}}
				>
					<div className="card-header">

						<p>
						<ErrorIcon color="error" style={{ marginTop: 4 }} />
							An error has occurred in this component.{' '}
							<span
								style={{ cursor: 'pointer', color: '#0077FF' }}
								onClick={() => {
									window.location.reload();
								}}
							>
								Reload this page
					</span>{' '}
						</p>
					</div>

					<button
						className="bg-primary text-light"
						// onClick={() =>
						// 	Sentry.showReportDialog({ eventId: this.state.eventId })
						// }
					>
						Report feedback
				</button>
				</div>
			);
		}
		return (
			<Suspense
				fallback={
					<div style={{ height: "100%", width: "100%", display: "flex" }}>
						<CircularProgress style={{ alignSelf: "center", margin: "auto", marginTop: 40 }} />
					</div>
				}
			>
				{this.props.children}
			</Suspense>
		);
	}
}

export default ErrorBoundaryWithSuspense;
